/**
 * 將 API 回傳的 period list 轉換為 UI 使用的時程項目
 *
 * status 判斷規則（以「週」為單位）：
 *   - current：start_at 所在的週 === 今天所在的週
 *   - past：start_at 所在的週 < 今天所在的週
 *   - future：start_at 所在的週 > 今天所在的週
 *
 * @param {Array} apiItems - API 回傳的 items 陣列
 * @returns {Array} 轉換後的時程項目
 */
export const parsePeriodList = (apiItems = []) => {
    const now = new Date();
    const todayWeekStart = getWeekStart(now);

    return apiItems.map((item) => {
        const startDate = new Date(item['start_at']);
        const endAt = item['end_at'];
        const endDate = endAt ? new Date(endAt) : null;
        const itemWeekStart = getWeekStart(startDate);

        let status;
        if (itemWeekStart.getTime() === todayWeekStart.getTime()) {
            status = 'current';
        } else if (itemWeekStart < todayWeekStart) {
            status = 'past';
        } else {
            status = 'future';
        }

        // 結束日為開始日 + 6 天（週六到週五）
        // const endDate = new Date(startDate);
        // endDate.setDate(endDate.getDate() + 6);
        const date = endDate 
          ? `${formatDate(startDate)} - ${formatDate(endDate)}` 
          : formatDate(startDate);
        // console.log('date', date);

        return {
            lighting_id: item.lighting_id,
            date,
            start_at: item.start_at,
            branches: item.monastery_items.map((m) => m.monastery_abbr).join('、'),
            monasteryList: item.monastery_items.map((m) => ({ id: m.monastery_id, name: m.monastery_abbr, has_lighting_post: m.has_lighting_post ?? false })),
            monasteryInds: item.monastery_items.map((m) => m.monastery_id),
            status,
            map_url: item.map_url || null,
            map_thumbs: item.map_thumbs || null,
        };
    });
};

/**
 * 取得某日期所在週的起始日（周六）
 * 配合傳燈活動每週六開始的慣例
 */
const getWeekStart = (date) => {
    const d = new Date(date);
    const day = d.getDay(); // 0=Sun, 6=Sat
    // 找到該日期前或當天的周六
    const diff = day >= 6 ? 0 : day + 1;
    d.setDate(d.getDate() - diff);
    d.setHours(0, 0, 0, 0);
    return d;
};

/**
 * 將日期格式化為 M/DD
 */
const formatDate = (date) => {
    const month = date.getMonth() + 1;
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}/${day}`;
};
